import { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';
import styled from '@emotion/styled';

import { useCobranca } from '../../hooks/useCobranca';
import { useGlobal } from './../../hooks/useGlobal';
import useWindow from '../../hooks/windowSet';
import api from '../../services/api';
import { formatFormDate, formatToLocaleCurrency, formatToLocaleDate } from '../../util/formats';
import { selecionarStatus } from '../../helper/tratarStatusCobranca';

import { ManipularCobranca } from '../ManipularCobranca';
import Status from '../Status';
import Modal from '../Modal/index';
import ModalIdCobranca from '../../components/ExcluirCobrancaModal';
import DetalhesCobranca from '../../components/DetalhesCobrancaModal';
import CobrancaFormEditar from '../../components/EditarCobrancaModal';

const TableCellStyled = styled(TableCell)`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 50px;
  letter-spacing: 0.005em;
  color: #3F3F55;
  padding: 2px;
`;

const TableCellConteudo = styled(TableCell)`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 0.005em;
  padding: 2px;
  color: #747488;
`;

export function TabelaCobranca() {
  const { cobrancas, setCobrancas, idCobranca, setIdCobranca } = useCobranca();
  const { token } = useGlobal();
  const [openConfirm, setOpenDelete] = useState(false);
  const [openDetalhes, setOpenDetalhes] = useState(false);
  const [textModal, setTextModal] = useState({});
  const [open, onClose, onOpen] = useWindow();
  const [page, setPage] = useState(0);


  useEffect(() => {
    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };

    try {
      const ListarCobrancas = async () => {
        return await api.get('cobrancas', config);
      };

      ListarCobrancas().then(({ data: listaDeCobrancas }) => {
        setCobrancas([...listaDeCobrancas]);
      });
    }
    catch (e) {
      console.error('erro>', e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cobrancas]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  function handleOpenModal(e, row) {
    e.preventDefault();

    setTextModal(row);
    setOpenDetalhes(true);
  };

  function handleOpenModalEditar(e, id) {
    e.preventDefault();

    const temp = cobrancas[id];
    const localCobrancaEditar = { ...temp };

    localCobrancaEditar.valor = (localCobrancaEditar.valor / 100);
    localCobrancaEditar.vencimento = formatFormDate(localCobrancaEditar.vencimento);

    setTextModal(localCobrancaEditar);
    onOpen();
  };

  function handleDeleteModal(id) {
    setIdCobranca(id);
    setOpenDelete(true);
  };

  return (
    <>
      <TableContainer
        component={Paper}
        elevation={0}
        style={{
          padding: '12px 23px 0 23px',
          background: '#FFFFFF',
          borderRadius: '30px',
        }}
      >
        <Table >
          <TableHead >
            <TableRow>
              <TableCellStyled >Cliente</TableCellStyled>
              <TableCellStyled >ID Cob.</TableCellStyled>
              <TableCellStyled >Valor</TableCellStyled>
              <TableCellStyled >Data de venc.</TableCellStyled>
              <TableCellStyled >Status</TableCellStyled>
              <TableCellStyled >Descrição</TableCellStyled>
              <TableCellStyled />
            </TableRow>
          </TableHead>

          <TableBody>
            {cobrancas.slice(page * 9, page * 9 + 9)
              .map((row, index) => (
                <TableRow key={row.id} sx={{ height: '70px', }} >
                  <TableCellConteudo component='th' scope='row'>
                    {row.nome}
                  </TableCellConteudo>

                  <TableCellConteudo
                    align='left'
                    sx={{ cursor: 'pointer', }}
                    onClick={e => handleOpenModal(e, row)}
                  >
                    {row.id}
                  </TableCellConteudo>

                  <TableCellConteudo align='left'>{formatToLocaleCurrency(row.valor)}</TableCellConteudo>

                  <TableCellConteudo align='left'>{formatToLocaleDate(row.vencimento)}</TableCellConteudo>

                  <TableCellConteudo align='left'>
                    <Status statusIndex={selecionarStatus(row.status, row.vencimento)} cobranca={true} />
                  </TableCellConteudo>

                  <TableCellConteudo
                    align='left'
                    sx={{
                      maxWidth: '10vw',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {row.descricao}
                  </TableCellConteudo>

                  <TableCellConteudo align='left'>
                    <Box
                      sx={{
                        ml: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '24px',
                      }}
                    >
                      <ManipularCobranca
                        tipo={'editar'}
                        onClick={e => handleOpenModalEditar(e, index)}
                      />
                      <ManipularCobranca
                        tipo={'excluir'}
                        onClick={() => handleDeleteModal(row.id)}
                      />
                    </Box>
                  </TableCellConteudo>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          component='div'
          count={cobrancas.length}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </TableContainer>

      {openConfirm &&
        <ModalIdCobranca
          setOpenDelete={setOpenDelete}
        />
      }

      {openDetalhes &&
        <DetalhesCobranca
          setOpenDetalhes={setOpenDetalhes}
          textModal={textModal}
        />
      }

      {open &&
        <Modal close={onClose}>
          <CobrancaFormEditar
            onClose={onClose}
            textEdit={textModal}
          />
        </Modal>
      }
    </>
  );
};
